import React from 'react';
import Loading from '../../components/elements/loading';

const LoadingPage: React.FC = () => {
  return <Loading />;
};

export default LoadingPage;
